// DS1.10
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import c from 'classnames';
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import SimpleTooltipContent from '../../SimpleTooltipContent';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import PopoverWrapper from '../../../popper/PopoverWrapper';
import s from './SimpleTooltip.scss';
const SimpleTooltip = (_param)=>{
    var { text, children, prefix, postfix, width, forceVisible = false, className, contentClassName } = _param, rest = _object_without_properties(_param, [
        "text",
        "children",
        "prefix",
        "postfix",
        "width",
        "forceVisible",
        "className",
        "contentClassName"
    ]);
    const { isVisible, onClick, onMouseEnter, onMouseLeave, onClose } = usePopoverOnInteraction({
        listenOnClicks: true,
        listenOnHover: true
    });
    const reverseTheme = useReverseTheme();
    const renderPopover = useCallback((popoverWrapperProps)=>/*#__PURE__*/ React.createElement(PopoverWrapper, _object_spread({
            contentClassName: c(s['popover-wrapper'], contentClassName),
            width: width,
            onClickOutside: onClose,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            forceTheme: reverseTheme
        }, popoverWrapperProps), /*#__PURE__*/ React.createElement(SimpleTooltipContent, {
            prefix: prefix,
            postfix: postfix
        }, text)), [
        width,
        text,
        prefix,
        postfix,
        onMouseEnter,
        onMouseLeave,
        onClose,
        reverseTheme,
        contentClassName
    ]);
    if (!text) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, _object_spread({
        isVisible: isVisible || forceVisible,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        className: c(s['root'], className),
        renderPopover: renderPopover
    }, rest), children);
};
SimpleTooltip.displayName = 'SimpleTooltip';
export default SimpleTooltip;
